export const CANONICAL_SHARE_BASE_URL = 'https://www.insightatlas.ai'

interface CanonicalShareTarget {
  researchId?: number | null
  intelligenceReportId?: string | null
}

export function buildCanonicalArticleShareUrl(researchId: number): string {
  if (!Number.isInteger(researchId) || researchId <= 0) {
    throw new Error('A valid numeric researchId is required to build an article share URL')
  }

  return `${CANONICAL_SHARE_BASE_URL}/article/${researchId}`
}

export function buildCanonicalReportShareUrl(reportId: string): string {
  const normalizedReportId = reportId.trim()
  if (!normalizedReportId) {
    throw new Error('A valid reportId is required to build a report share URL')
  }

  return `${CANONICAL_SHARE_BASE_URL}/report/${normalizedReportId}`
}

export function buildCanonicalShareUrl({
  researchId,
  intelligenceReportId,
}: CanonicalShareTarget): string | null {
  if (intelligenceReportId) {
    return buildCanonicalReportShareUrl(intelligenceReportId)
  }

  if (typeof researchId === 'number' && Number.isInteger(researchId) && researchId > 0) {
    return buildCanonicalArticleShareUrl(researchId)
  }

  return null
}
